import { StoreProps } from '@/app/models/store'
import { useIntl } from 'react-intl'
import { LuxBadgeLabel, LuxLoadingCircle } from '@lux/wardrobe-lib'
import { statusColors } from '@/app/utils/statusColorMap'
import './ProjectSpecs.scss'
import { useDispatch } from 'react-redux'
import { Actions } from '@/app/redux/actions/new-resource'

const ProjectSpecs = (props: {
    title: string
    status: string
    subtitle: string
    details: {
        value: string | number
        label: string
        disabled?: boolean
    }[]
    stores?: StoreProps[]
    loading?: boolean
    projectId?: string
}) => {
    const { title, status, subtitle, details, stores, loading, projectId } = props

    const componentClass = 'smart-modals-news-execution-project-specs'

    const intl = useIntl()
    const dispatch = useDispatch()

    const CopyLinkComponent = () => {
        const copyLinkClass = `${componentClass}__copy-link`
        return (
            <div
                className={copyLinkClass}
                onClick={() => {
                    navigator.clipboard.writeText(
                        `${window.location.origin}/activity?projectId=${projectId}`
                    )

                    dispatch({
                        type: Actions.COPY_LINK_TO_CLIPBOARD_SUCCESS,
                        toastList: [
                            {
                                title: 'Success',
                                text: intl.formatMessage({
                                    id: 'home.link_copied_successfully',
                                    defaultMessage: 'Link copied successfully!',
                                }),
                            },
                        ],
                    })
                }}>
                <span className={`${copyLinkClass}__icon cu cu-copy`} />
                <span className={`${copyLinkClass}__title text-mini`}>
                    {intl.formatMessage({
                        id: 'copy_link',
                        defaultMessage: 'Copy link',
                    })}
                </span>
            </div>
        )
    }

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__header`}>
                <h2 className={`${componentClass}__title`}>{title}</h2>
                {/* <CopyLinkComponent /> */}
            </div>
            {loading && (
                <div className={`${componentClass}__loader`}>
                    <LuxLoadingCircle active={true} />
                </div>
            )}
            {!loading && (
                <>
                    <div className={`${componentClass}__status`}>
                        {status && (
                            <LuxBadgeLabel
                                label={intl.formatMessage({
                                    id: `smart.project.status.${status}`,
                                    defaultMessage: status,
                                })}
                                color={statusColors[status]}
                            />
                        )}
                    </div>
                    <h2 className={`${componentClass}__subtitle`}>{subtitle}</h2>
                    {!!details?.length && (
                        <div className={`${componentClass}__details`}>
                            {details.map(
                                (
                                    d: {
                                        value: string
                                        label: string
                                        valueKey: string
                                        disabled: boolean
                                        valueList: string[]
                                    },
                                    i: number
                                ) => {
                                    if (d.disabled) return <></>
                                    return (
                                        <div
                                            key={i}
                                            className={`${componentClass}__details__detail`}>
                                            <span className={`${componentClass}__label`}>
                                                {d.label}
                                            </span>
                                            {!d.valueList && (
                                                <strong>
                                                    {!d.valueKey
                                                        ? d.value
                                                        : intl.formatMessage({
                                                              id: d.valueKey,
                                                              defaultMessage: d.value,
                                                          })}
                                                </strong>
                                            )}
                                            <div>
                                                {d.valueList &&
                                                    d.valueList.map((v) => (
                                                        <div>
                                                            <strong>{v}</strong>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )
                                }
                            )}
                        </div>
                    )}
                    {status !== 'draft' && status !== 'toBeReleased' && stores?.length > 0 && (
                        <div className={`${componentClass}__stores`}>
                            <div className={`${componentClass}__stores__store`}>
                                <strong>
                                    {intl.formatMessage({
                                        id: 'modals.news_execution.project_specs.stores.selected_stores',
                                        defaultMessage: 'Selected Stores',
                                    })}
                                </strong>
                            </div>
                            {stores.map((s: StoreProps, i: number) => {
                                return (
                                    <div key={i} className={`${componentClass}__stores__store`}>
                                        <span>{s.storeName}</span>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default ProjectSpecs
